import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const TooltipWrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding: 5px;
	z-index: 1000;
`;

export const TooltipHeader = styled.div`
	font-weight: bold;
	margin-bottom: 6px;
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	color: ${colors.grey7};
	text-align: center;
`;

export const TooltipGrid = styled.div`
	display: grid;
	grid-template-columns: minmax(12px, 12px) 2fr 1fr;
	width: 100%;
`;

export const TooltipRowValue = styled.div`
	display: flex;
	align-items: center;
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	color: ${colors.grey7};
	justify-content: flex-end;
	text-transform: uppercase;
`;
export const TooltipRowName = styled.div`
	display: flex;
	align-items: center;
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	color: ${colors.grey5};
	padding-right: 16px;
	text-transform: uppercase;
`;

export const ColorWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export const ColorSymbol = styled.div`
	min-width: 6px;
	max-width: 6px;
	min-height: 6px;
	max-height: 6px;
	background-color: ${({ color }) => color};
	border-radius: 50%;
`;
export const LegendWrapper = styled.div`
	display: flex;
	margin-right: auto;
	margin-left: auto;
	justify-content: space-evenly;
	> span {
		display: flex;
	}
`;
